import Mutations from '../../odata/mutations';

export default { ...new Mutations('shopTime'), ...new Mutations('shopTimes') };
